// Unpublished Work © 2023-2024 Deere & Company.

export const CATEGORIES = {
  PROMOTIONS: "promotions-service",
  SLA: "sla",
  ORDER_SERVICE: "orders-service",
  ORDER_CONSOLIDATION: "order_consolidation",
  EXTREME_UI: "jdpo-xtreme-ui",
  PARTS: "parts-service",
  CLAIMS_SERVICE: "claims-service",
  RETURNS: "returns-service",
  INVOICE_SERVICE: "invoice-service",
  HANDLING_UNIT_SERVICE: "handling-unit-service",
  CORE_ELIGIBILITIES_SERVICE: "core-eligibilities-service",
  ALERTS_SERVICE: "alerts-service",
  D2D_SERVICE: "d2d-service",
};

export const TOGGLES = {
  ENABLE_PROMOTIONS: "enable_promotions",
  ENABLE_SLA: "enable_sla",
  ENABLE_ORDER_SERVICE_FIELD: "enable_order_service_field",
  ENABLE_ORDERS: "enable_orders",
  DO_NOT_CONSOLIDATE_ORDER: "do_not_consolidate_order",
  CREDIT_STATUS: "credit_status",
  SHOW_PARTS_IMAGE: "show_parts_image",
  DISPLAY_BACKORDER_DETAILS: "display_backorder_details",
  ENABLE_CLAIMS_BY_HU: "enable_claims_by_hu",
  ENABLE_SURPLUS_RETURNS: "enable_surplus_returns",
  ENABLE_SURPLUS_RETURN_CSOO: "enable_surplus_return_csoo",
  ENABLE_CORE_RETURNS: "enable_core_returns",
  ENABLE_CLAIMS: "enable_claims",
  ENABLE_INVOICES: "enable_invoices",
  DISABLE_REQUEST_CANCELLATION_BUTTON: "disable_line_cancellation",
  DISABLE_STOCK_ORDER: "disable_stock_order",
  DISABLE_EMERGENCY_ORDER: "disable_emergency_order",
  ENABLE_PROMOTION_ORDER: "enable_promotion_order",
  HIDE_PROMISE_DATE: "hide_promise_date",
  SHOW_PARTS_RETURNABLE_INDICATOR: "show_parts_returnable_indicator",
  SHOW_ALTERNATIVE_PARTS: "show_alternative_parts",
  ENABLE_PARTS_INFO: "enable_parts_info",
  ENABLE_RETURNS: "enable_returns",
  ENABLE_CREATE_RETURNS: "enable_create_returns",
  ENABLE_HANDLING_UNITS: "enable_handling_units",
  JDPS_SERVICE_DEALER: "jdps-service-dealer",
  ENABLE_NFE_VALIDATION: "enable_nfe_validation",
  ENABLE_SURPLUS_RETURN_DEALER_PREPARATION:
    "enable_surplus_return_dealer_preparation",
  ENABLE_DAILY_RETURN_DEALER_PREPARATION:
    "enable_daily_return_dealer_preparation",
  ENABLE_ADDRESS_OVERRIDE: "address_override_enable_validations",
  ENABLE_ADDRESS_OVERRIDE_CLEANSER: "address_override_enable_cleanser",
  ENABLE_ADDRESS_OVERRIDE_ADDRESS_SELECTION:
    "address_override_enable_address_selection",
  ENABLE_MARKUP_PRICE: "enable_markup_price",
  ENABLE_LINK_JDPOINT: "enable_link_jdpoint",
  ENABLE_INVOICE_CONSOLIDATION: "enable_invoice_consolidation",
  M2NO_ALLOW_USER_TO_DISABLE_AUTO_SUBMIT_JDPOINT_ORDER:
    "m2no_allow_user_to_disable_auto_submit_jdpoint_order",
  ENABLE_CORE_ELIGIBILITIES: "enable_core_eligibilities",
  DISABLE_LEGACY_INVENTORY: "disable_legacy_inventory",
  ENABLE_EXTERNAL_LINKS: "enable_external_links",
  ENABLE_RPM_FOR_JDPRISM: "enable_RPM",
  ENABLE_ALERTS_AND_NOTIFICATIONS: "enable_alerts_and_notifications",
  ENABLE_VENDOR_DIRECT_RETURN: "enable_vendor_direct_return",
  ENABLE_D2D: "enable_d2d",
  ENABLE_D2D_TIME_TO_RESPOND: "enable_request_timeoutValue_d2d",
  ENABLE_HAZARDOUS_PARTS: "enable_hazardous_parts",
  ENABLE_REPORTS: "enable_reports",
  ENABLE_SERIAL_NUMBER: "enable_serial_number",
  ENABLE_JDPOINT_ALL_BACKORDERS: "enable_jdpoint_all_backorders",
  ENABLE_ADDRESS_OVERRIDE_UPS: "address_override_ups_validation_enabled",
  ENABLE_BROADCAST_MESSAGES_NOTIFICATIONS:
    "enable_broadcast_messages_notifications",
  ENABLE_JDPS_POSTSHIP_ACTIVITIES: "enable_jdps_postship_activities",
  ENABLE_JDPS_SURPLUS_RETURN_ACTIVITIES:
    "enable_jdps_surplus_return_activities",
  MASK_SHIP_TO_ADDRESS: "mask_ship_to_address",
  HIDE_PROMOTION_DISCOUNT_INFO: "hide_promotion_discount_info",
  HIDE_ORDERS_BY_LINE_STATUS: "hide_orders_by_line_status",
  ENABLE_SUPPLIER_INVENTORY_LINK: "enable_supplier_inventory_link",
};

export const ADDITIONAL_FIELDS = {
  ORDER_TYPE: "order_type",
  LINE_STATUS: "line_status",
};

// now forward we will be using ENUM as type instead of simple Object map

export enum AdditionalFieldsKey {
  ORDER_TYPE = "order_type",
  LINE_STATUS = "line_status",
}

export enum CategoryKey {
  PROMOTIONS_SERVICE = "promotions-service",
  SLA = "sla",
  ORDER_SERVICE = "orders-service",
  ORDER_CONSOLIDATION = "order_consolidation",
  EXTREME_UI = "jdpo-xtreme-ui",
  PARTS_SERVICE = "parts-service",
  CLAIMS_SERVICE = "claims-service",
  RETURNS_SERVICE = "returns-service",
  INVOICE_SERVICE = "invoice-service",
  HANDLING_UNIT_SERVICE = "handling-unit-service",
  CORE_ELIGIBILITIES_SERVICE = "core-eligibilities-service",
  ALERTS_SERVICE = "alerts-service",
  BROADCAST_MESSAGES_SERVICE = "broadcast-messages-service",
}

export enum ToggleKey {
  ENABLE_PROMOTIONS = "enable_promotions",
  ENABLE_SLA = "enable_sla",
  ENABLE_ORDER_SERVICE_FIELD = "enable_order_service_field",
  ENABLE_ORDERS = "enable_orders",
  DO_NOT_CONSOLIDATE_ORDER = "do_not_consolidate_order",
  CREDIT_STATUS = "credit_status",
  SHOW_PARTS_IMAGE = "show_parts_image",
  DISPLAY_BACKORDER_DETAILS = "display_backorder_details",
  ENABLE_CLAIMS_BY_HU = "enable_claims_by_hu",
  ENABLE_SURPLUS_RETURNS = "enable_surplus_returns",
  ENABLE_CORE_RETURNS = "enable_core_returns",
  ENABLE_CLAIMS = "enable_claims",
  ENABLE_INVOICES = "enable_invoices",
  DISABLE_REQUEST_CANCELLATION_BUTTON = "disable_line_cancellation",
  DISABLE_STOCK_ORDER = "disable_stock_order",
  DISABLE_EMERGENCY_ORDER = "disable_emergency_order",
  ENABLE_PROMOTION_ORDER = "enable_promotion_order",
  HIDE_PROMISE_DATE = "hide_promise_date",
  SHOW_PARTS_RETURNABLE_INDICATOR = "show_parts_returnable_indicator",
  SHOW_ALTERNATIVE_PARTS = "show_alternative_parts",
  ENABLE_PARTS_INFO = "enable_parts_info",
  ENABLE_RETURNS = "enable_returns",
  ENABLE_CREATE_RETURNS = "enable_create_returns",
  ENABLE_HANDLING_UNITS = "enable_handling_units",
  JDPS_SERVICE_DEALER = "jdps-service-dealer",
  ENABLE_NFE_VALIDATION = "enable_nfe_validation",
  ENABLE_ADDRESS_OVERRIDE = "address_override_enable_validations",
  ENABLE_ADDRESS_OVERRIDE_CLEANSER = "address_override_enable_cleanser",
  ENABLE_ADDRESS_OVERRIDE_ADDRESS_SELECTION = "address_override_enable_address_selection",
  ENABLE_MARKUP_PRICE = "enable_markup_price",
  ENABLE_LINK_JDPOINT = "enable_link_jdpoint",
  ENABLE_INVOICE_CONSOLIDATION = "enable_invoice_consolidation",
  ENABLE_SURPLUS_RETURN_DEALER_PREPARATION = "enable_surplus_return_dealer_preparation",
  ENABLE_DAILY_RETURN_DEALER_PREPARATION = "enable_daily_return_dealer_preparation",
  ENABLE_SURPLUS_RETURN_CSOO = "enable_surplus_return_csoo",
  M2NO_ALLOW_USER_TO_DISABLE_AUTO_SUBMIT_JDPOINT_ORDER = "m2no_allow_user_to_disable_auto_submit_jdpoint_order",
  ENABLE_CORE_ELIGIBILITIES = "enable_core_eligibilities",
  DISABLE_LEGACY_INVENTORY = "disable_legacy_inventory",
  ENABLE_EXTERNAL_LINKS = "enable_external_links",
  ENABLE_RPM_FOR_JDPRISM = "enable_RPM",
  ENABLE_ALERTS_AND_NOTIFICATIONS = "enable_alerts_and_notifications",
  ENABLE_VENDOR_DIRECT_RETURN = "enable_vendor_direct_return",
  ENABLE_D2D = "enable_d2d",
  ENABLE_HAZARDOUS_PARTS = "enable_hazardous_parts",
  ENABLE_REPORTS = "enable_reports",
  ENABLE_SERIAL_NUMBER = "enable_serial_number",
  ENABLE_JDPOINT_ALL_BACKORDERS = "enable_jdpoint_all_backorders",
  ENABLE_BROADCAST_MESSAGES_NOTIFICATIONS = "enable_broadcast_messages_notifications",
  MASK_SHIP_TO_ADDRESS = "mask_ship_to_address",
  HIDE_PROMOTION_DISCOUNT_INFO = "hide_promotion_discount_info",
  HIDE_ORDERS_BY_LINE_STATUS = "hide_orders_by_line_status",
}
